import { extractApiErrorItem } from './errorMessage';
import { AuthErrorCode } from './authErrorCodes';

export interface AccountLockoutInfo {
  isLocked: boolean;
  until?: Date;
}

/**
 * Detect the account-lockout error returned by the auth endpoints after too many failed login
 * attempts. Identified by error code, with the lockout expiry carried as an ISO-8601 string in
 * `details`:
 *   { "code": "hs-auth-2401", "message": "Account is temporarily locked.",
 *     "details": "2026-07-01T10:15:00.0000000+00:00" }
 *
 * Note the backend only returns this code when the submitted password was correct - a wrong password
 * on a locked account answers with the generic AuthenticationFailed instead, so that the lockout
 * state cannot be used to enumerate accounts.
 */
export function parseAccountLockout(error: unknown): AccountLockoutInfo {
  const item = extractApiErrorItem(error);

  if (item?.code !== AuthErrorCode.AccountLocked) {
    return { isLocked: false };
  }

  if (typeof item.details === 'string' && item.details.trim().length > 0) {
    const until = new Date(item.details);
    if (!Number.isNaN(until.getTime())) {
      return { isLocked: true, until };
    }
  }

  return { isLocked: true };
}
